module.exports = __webpack_public_path__ + "img/horizontal_6_5_8017.e224e922.png";